import React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  Instrument,
  InstrumentType,
  MaterialColor,
} from "@syos-music/instruments";
import { Product } from "@syos-music/products";

import { Box, Typography } from "@mui/material";
import { Replay as ReturnIcon } from "mdi-material-ui";

const OriginalsType = Product.displayModes.originalsMouthpiece.OriginalsType;

const Icon = () => <ReturnIcon />;

const Title = () => <span>Retour produit</span>;

const QUERY = gql`
  query ($id: ID) {
    signatureMouthpiece(id: $id) {
      id
      signature
    }
  }
`;

function Item({ item, isExchange }) {
  const { data } = useQuery(QUERY, {
    variables: {
      id: item.exchange?.signatureMouthpieceId,
    },
    skip: !item.exchange?.signatureMouthpieceId,
  });

  let instrument, instrumentType;
  if (isExchange) {
    instrument = item.exchange?.instrument ?? "saxophone";
    instrumentType =
      item.exchange.instrumentType ?? item.exchange.saxophoneType;
  }

  return (
    <li>
      <Typography component="span">
        <span>{item.quantity} &times; </span>
        <Box
          component="span"
          sx={{
            "& em": {
              color: (t) => t.palette.primary.main,
              fontWeight: 700,
              fontStyle: "normal",
            },
          }}
        >
          <Product.Title product={item.product} options={item.options} />
        </Box>
      </Typography>

      {isExchange && (
        <>
          <br />
          <Typography component="span">
            <strong>Modifications demandées :</strong>
          </Typography>

          <ul>
            {instrumentType && (
              <li>
                <Typography component="span" color="primary">
                  Type de <Instrument instrument={instrument} />
                </Typography>
                &nbsp;:{" "}
                <InstrumentType
                  instrument={instrument}
                  instrumentType={instrumentType}
                />
              </li>
            )}

            {item.exchange?.signatureMouthpieceId && (
              <li>
                <Typography component="span" color="primary">
                  Artiste
                </Typography>
                &nbsp;:{" "}
                {data?.signatureMouthpiece?.signature ??
                  item.exchange.signatureMouthpieceId}
              </li>
            )}

            {item.exchange?.originalsType && (
              <li>
                <Typography component="span" color="primary">
                  Originals
                </Typography>
                &nbsp;:{" "}
                <OriginalsType originalsType={item.exchange.originalsType} />
              </li>
            )}

            {item.exchange?.tipOpening && (
              <li>
                <Typography component="span" color="primary">
                  Ouverture
                </Typography>
                &nbsp;: {item.exchange?.tipOpening}
              </li>
            )}

            {item.exchange?.mouthpieceColor && (
              <li>
                <Typography component="span" color="primary">
                  Couleur du bec
                </Typography>
                &nbsp;:{" "}
                <MaterialColor
                  color={item.exchange?.mouthpieceColor}
                  variant="preview-text"
                />
              </li>
            )}

            {item.exchange?.ligatureColor && (
              <li>
                <Typography component="span" color="primary">
                  Couleur de la ligature
                </Typography>
                &nbsp;:{" "}
                <MaterialColor
                  color={item.exchange?.ligatureColor}
                  variant="preview-text"
                />
              </li>
            )}
          </ul>
        </>
      )}
    </li>
  );
}

const Content = ({ orderEvent }) => {
  return (
    <>
      <Typography paragraph>
        <strong>Type de retour :</strong> {orderEvent.return.type}
      </Typography>

      <Typography paragraph>
        <strong>Produits :</strong>
      </Typography>

      <ul>
        {orderEvent.return.items.map((item, idx) => (
          <Item
            key={idx}
            item={item}
            isExchange={orderEvent.return.type === "EXCHANGE"}
          />
        ))}
      </ul>

      <Typography>
        <strong>Motif :</strong>
      </Typography>
      <Typography paragraph>{orderEvent.return.reason}</Typography>

      {orderEvent.return.trelloUrl && (
        <Typography>
          <a
            href={orderEvent.return.trelloUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Ouvrir dans Trello
          </a>
        </Typography>
      )}
    </>
  );
};

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_ReturnEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_Return {
        return {
          id
          type

          items {
            product {
              id
              name
              displayMode
            }
            quantity
            options
            exchange
          }

          reason
          trelloUrl
        }
      }
    }
  `,
};

const Event = {
  Icon,
  Title,
  Content,
  fragments,
};

export default Event;
